import React, {  useState, useEffect } from 'react'
import {  Link } from 'react-router-dom'
import axios from 'axios'

export const NavigationAOComponent = ({ aoId, pageType, setDetailWhenReceived }) => {
    const [aoDetail, setAoDetail] = useState();

    useEffect(() => {
        axios.get('/api/aoget/detail?id=' + aoId)
            .then(response => {
                setAoDetail(response.data)
                if (setDetailWhenReceived) {
                    setDetailWhenReceived(response.data);
                }
            });
    }, [aoId]);

    let previousIcon = <></>;
    if (aoDetail && aoDetail.previousId) {
        previousIcon = <Link to={'/aos/' + pageType + '/' + aoDetail.previousId}><i className="pi pi-arrow-circle-left text-primary"  ></i></Link>
    }

    let nextIcon = <></>
    if (aoDetail && aoDetail.nextId) {
        nextIcon = <Link to={'/aos/' + pageType + '/' + aoDetail.nextId}><i className="pi pi-arrow-circle-right text-primary"  ></i></Link>
    }

    let homeIcon = <></>
    if (aoDetail && aoDetail.runId) {
        homeIcon = <Link to={"/aos/result/" + aoDetail.runId}><i className="pi pi-home text-primary"  ></i></Link>
    }

    let detailIcon = <></>
    if (aoDetail && aoDetail.id) {
        detailIcon = <Link to={"/aos/ao/" + aoDetail.id}><i className="pi pi-info-circle text-primary"  ></i></Link>
    }

    const getTitre = () => {
        if (aoDetail && aoDetail.titre) {
            return aoDetail.titre;
        }
        else {
            return "non trouvé";
        }
    }

    const getReference = () => {
        if (aoDetail && aoDetail.reference) {
            return aoDetail.reference;
        }
        else {
            return "non trouvé";
        }
    }

    let pageMatched = <></>
    let pageHtml = <></>

    if (pageType !== "aohtml" && aoDetail && aoDetail.id) {
        pageHtml = <>&nbsp; &nbsp; &nbsp;<Link to={"/aos/aohtml/" + aoDetail.id}><i className="pi pi-map text-primary" ></i></Link> </>
    }

    if (pageType !== "matched" && aoDetail && aoDetail.id) {
        pageMatched = <>&nbsp; &nbsp; &nbsp;<Link to={"/aos/matched/" + aoDetail.id}><i className="pi pi-check-square text-primary"  ></i></Link> </>
    }

    if (aoDetail) {
        return <div className="row mb-2">
            <div className="col">{previousIcon}
            </div>
            <div className="col-10 text-center d-flex flex-column">
                <div>{homeIcon} &nbsp; &nbsp; &nbsp;  {detailIcon}  {pageHtml} {pageMatched}</div>
                <span > {getTitre()} - {getReference()}  </span>
            </div>
            <div className="col">{nextIcon} </div>
        </div>

    }

    return <></>
}









